const Kvkk = () => {
  return (
    <div className="mss">
      <h2>MOBİL ASSISTANCE SERVİS HİZMETLERİ DENETİM DANIŞMANLIK TİCARET LTD. ŞTİ.</h2>
      <h2>KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ AYDINLATMA METNİ</h2>

      <h2>1. VERİ SORUMLUSUNUN KİMLİĞİ</h2>
      <ul>
        <li>
          Ticaret Unvanı: Mobil Assistance Servis Hizmetleri Denetim Danışmanlık Ticaret Ltd. Şti.
        </li>
        <li>
          Adres: GevherNesibe Mah. Alpay Sok. Lifos Tower 4/7-8 Kocasinan / Kayseri
        </li>
        <li>Çağrı Merkezi: 0850 255 02 03</li>
        <li>E-Posta: info@mobilassistance.com</li>
        <li>İnternet Sitesi: www.mobilassistance.com</li>
      </ul>

      <h2>2. İŞLENEN KİŞİSEL VERİ KATEGORİLERİ</h2>
      <p>
        Hizmet talebinizin alınması, operasyonel organizasyonun sağlanması ve hizmetin eksiksiz ifası
        amacıyla işlenen kişisel verileriniz aşağıda kategorize edilmiştir:
      </p>
      <ul>
        <li>
          Kimlik Bilgileri: Ad, soyad, T.C. kimlik numarası (veya vergi kimlik numarası).
        </li>
        <li>
          İletişim Bilgileri: Telefon numarası, e-posta adresi, fatura ve bildirim adresi.
        </li>
        <li>
          Konum / Lokasyon Bilgileri: Çekici veya kurtarma hizmetinin yönlendirileceği anlık GPS
          konumu, paylaşılan canlı konum, mahsur kalınan adres veya yol güzergâhı bilgisi.
        </li>
        <li>
          Araç ve Kaza/Arıza Bilgileri: Araç plakası, marka/model, ruhsat bilgileri, arıza veya hasar
          durumu, olay yeri fotoğrafları, kaza tespit tutanağı veya kolluk kuvveti tutanak bilgileri.
        </li>
        <li>
          İşlem ve Ses Kayıtları: 0850 255 02 03 numaralı çağrı merkezimiz ile yapılan görüşmelerin
          ses kayıtları, talep/şikâyet geçmişi, sipariş ve operasyonel takip kayıtları.
        </li>
        <li>
          Finans ve Muhasebe Bilgileri: Ödeme yöntemi, fatura bilgileri, tahsilat makbuz ve referans
          numaraları (Kredi kartı ve banka kartı bilgileriniz doğrudan ilgili banka veya lisanslı
          ödeme kuruluşunun 3D Secure güvenli altyapısında işlenmekte olup Şirketimiz sunucularında
          kart bilgisi kesinlikle saklanmamaktadır).
        </li>
        <li>
          İşlem Güvenliği Bilgileri: Web sitesi veya mobil kanallar üzerindeki oturum ve işlem
          logları, IP adresi ve teknik çerez (cookie) kayıtları.
        </li>
      </ul>

      <h2>3. KİŞİSEL VERİLERİN İŞLENME AMAÇLARI</h2>
      <p>
        Kişisel verileriniz, KVKK’nın 4. maddesinde belirtilen genel ilkelere (hukuka ve dürüstlük
        kuralına uygun olma, belirli, açık ve meşru amaçlara bağlı kalma, amaçla bağlantılı, sınırlı
        ve ölçülü olma) uygun olarak aşağıdaki amaçlarla işlenmektedir:
      </p>
      <ul>
        <li>
          Talep edilen çekici, kurtarma, yol yardım, lastik temini, akü takviyesi, yakıt desteği ve
          ikame araç asistans hizmetlerinin organizasyonunun yapılması ve operasyonel sürecin
          yürütülmesi,
        </li>
        <li>
          Bölgedeki anlaşmalı çekici veya kurtarıcı operatörünün aracınızın bulunduğu konuma hızlı ve
          güvenli şekilde sevk edilmesi,
        </li>
        <li>
          Mesafeli satış ve hizmet sözleşmelerinin kurulması, uygulanması ve satış sonrası destek
          süreçlerinin yönetilmesi,
        </li>
        <li>
          Çağrı merkezi görüşmelerinin hizmet kalitesinin denetlenmesi, talep teyidi ve olası hukuki
          uyuşmazlıklarda ispat amacıyla kayıt altına alınması,
        </li>
        <li>
          Faturalandırma, muhasebe, tahsilat ve finansal kayıt süreçlerinin yürütülmesi,
        </li>
        <li>
          İptal, iade ve operasyonel hasar süreçlerinin takibi ve sonuçlandırılması,
        </li>
        <li>
          Yetkili kamu kurum ve kuruluşları ile adli/idari mercilerin mevzuata uygun bilgi ve belge
          taleplerinin karşılanması.
        </li>
      </ul>

      <h2>4. KİŞİSEL VERİ İŞLEMENİN HUKUKİ SEBEPLERİ</h2>
      <p>
        Kişisel verileriniz, 6698 sayılı KVKK’nın 5. maddesinde belirtilen aşağıdaki hukuki sebeplere
        dayanılarak işlenmektedir:
      </p>
      <ul>
        <li>
          KVKK m.5/2-(c) – Sözleşmenin Kurulması ve İfası: Hizmet sözleşmesinin akdedilmesi, çekici
          operatörünün olay yerine yönlendirilmesi ve talep edilen yol yardım ediminin ifası için
          veri işlemenin zorunlu olması.
        </li>
        <li>
          KVKK m.5/2-(ç) – Hukuki Yükümlülüğün Yerine Getirilmesi: 6502 sayılı Tüketicinin Korunması
          Hakkında Kanun, Vergi Usul Kanunu, Türk Ticaret Kanunu ve ilgili tüketici/mesafeli sözleşme
          mevzuatından doğan yasal yükümlülüklerin yerine getirilmesi.
        </li>
        <li>
          KVKK m.5/2-(e) – Bir Hakkın Tesisi, Kullanılması veya Korunması: Tüketici Hakem Heyetleri,
          mahkemeler ve icra daireleri nezdinde doğabilecek uyuşmazlıklarda Şirketimizin haklarının
          korunması ve ispat yükümlülüğünün yerine getirilmesi.
        </li>
        <li>
          KVKK m.5/2-(f) – Meşru Menfaat: Temel hak ve özgürlüklerinize zarar vermemek kaydıyla;
          operasyonel güvenliğin sağlanması, sistem altyapısının korunması ve hizmet kalitesinin
          artırılması için veri işlemenin zorunlu olması.
        </li>
      </ul>

      <h2>5. KİŞİSEL VERİLERİN AKTARILDIĞI TARAFLAR VE AKTARIM AMAÇLARI</h2>
      <p>
        Kişisel verileriniz; KVKK’nın 8. ve 9. maddelerine uygun olarak, yalnızca yukarıda belirtilen
        amaçların gerçekleştirilmesi doğrultusunda ve gerekli teknik/idari güvenlik önlemleri
        alınarak:
      </p>
      <ul>
        <li>
          Anlaşmalı Çekici ve Kurtarıcı Operatörlerine: Hizmetin sahada fiilen yerine getirilebilmesi
          için gereken ölçüde (konum, ad-soyad, telefon ve araç bilgileri ile sınırlı olarak),
        </li>
        <li>
          Teknik ve Bilişim Altyapı Sağlayıcılarına: Sunucu barındırma, veri tabanı, SMS gönderimi ve
          çağrı merkezi santral hizmeti sunan hizmet sağlayıcılara,
        </li>
        <li>
          Mali Müşavir ve Hukuk Danışmanlarına: Finansal, vergisel, denetimsel ve hukuki danışmanlık
          süreçlerinin yürütülmesi amacıyla,
        </li>
        <li>
          Yetkili Kamu Kurum ve Kuruluşlarına: Kanunen yetkili kamu kurumları, kolluk kuvvetleri,
          adli makamlar ve Tüketici Hakem Heyetleri’nin yasal talepleri doğrultusunda,
        </li>
      </ul>
      <p>
        aktarılabilmektedir. Kişisel verileriniz ticari veya pazarlama amacıyla izniniz olmaksızın
        üçüncü taraflarla paylaşılmaz.
      </p>

      <h2>6. KİŞİSEL VERİLERİN TOPLANMA YÖNTEMLERİ</h2>
      <p>
        Kişisel verileriniz; web sitemiz (www.mobilassistance.com), mobil kanallarımız, 0850 255 02 03
        numaralı çağrı merkezimiz üzerinden yapılan telefon görüşmeleri, anlık mesajlaşma hatları
        (WhatsApp vb.), e-posta yazışmaları ve elektronik başvuru formları aracılığıyla tamamen veya
        kısmen otomatik yöntemlerle toplanmaktadır.
      </p>

      <h2>7. İLGİLİ KİŞİNİN HAKLARI (KVKK MADDE 11)</h2>
      <p>
        Kişisel veri sahibi olarak KVKK’nın 11. maddesi uyarınca Mobil Assistance’a başvurarak
        aşağıdaki haklarınızı kullanabilirsiniz:
      </p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
        <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
        <li>
          Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
          öğrenme,
        </li>
        <li>
          Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
        </li>
        <li>
          Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini
          isteme,
        </li>
        <li>
          KVKK m.7 çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme,
        </li>
        <li>
          Düzeltme, silme veya yok etme işlemlerinin kişisel verilerinizin aktarıldığı üçüncü kişilere
          bildirilmesini isteme,
        </li>
        <li>
          İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
          aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
        </li>
        <li>
          Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde
          zararın giderilmesini talep etme.
        </li>
      </ul>

      <h2>8. BAŞVURU YÖNTEMİ VE İLETİŞİM</h2>
      <p>
        Yukarıda belirtilen haklarınıza ilişkin taleplerinizi; Veri Sorumlusuna Başvuru Usul ve
        Esasları Hakkında Tebliğ uyarınca:
      </p>
      <ul>
        <li>
          Şirketimizin GevherNesibe Mah. Alpay Sok. Lifos Tower 4/7-8 Kocasinan / Kayseri
          adresine kimliğinizi tevsik edici belgeler ile şahsen yazılı olarak veya noter kanalıyla,
        </li>
        <li>
          Sistemimizde kayıtlı bulunan e-posta adresiniz üzerinden info@mobilassistance.com adresine
          e-posta göndererek,
        </li>
      </ul>
      <p>
        Şirketimize iletebilirsiniz. Başvurularınız talebin niteliğine göre en kısa sürede ve en geç
        30 (otuz) gün içerisinde ücretsiz olarak sonuçlandırılacaktır.
      </p>
    </div>
  )
}

export default Kvkk
